import React from 'react';
import { useAppStore } from '../../store/appStore';

export const TextDisplay: React.FC = () => {
  const { currentGesture, gestureHistory } = useAppStore();

  return (
    <div className="text-display">
      <div className="current-gesture">
        <h3>Current Gesture</h3>
        {currentGesture ? (
          <div className="gesture-info">
            <div className="gesture-name">{currentGesture.gesture}</div>
            <div className="gesture-confidence">
              Confidence: {(currentGesture.confidence * 100).toFixed(1)}%
            </div>
          </div>
        ) : (
          <div className="no-gesture">No gesture detected</div>
        )}
      </div>

      <div className="gesture-history">
        <h3>History</h3>
        <div className="history-list">
          {gestureHistory.length === 0 ? (
            <p className="empty-history">No gestures yet</p>
          ) : (
            gestureHistory.slice().reverse().map((gesture, index) => (
              <div key={`${gesture.timestamp}-${index}`} className="history-item">
                <span className="history-gesture">{gesture.gesture}</span>
                <span className="history-confidence">
                  {(gesture.confidence * 100).toFixed(0)}%
                </span>
                <span className="history-time">
                  {new Date(gesture.timestamp).toLocaleTimeString()}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};
